module.exports = __webpack_public_path__ + "static/media/tranquilidade.e899713f.png";